interface IErrorAlertProps {
    errorTitle?: string;
    errorDescription: string;
}

import { AlertCircle } from "lucide-react"
 
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "../../components/ui/alert"

export const ErrorAlert: React.FC<IErrorAlertProps> = ({ errorTitle="Error", errorDescription}) => {
    return (
        <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>{errorTitle}</AlertTitle>
            <AlertDescription>
                {errorDescription}
            </AlertDescription>
        </Alert>
    )
}